<template>
    <button class="games-hedef-sayi-bulalim-rounded-gridant-secondary text-white px-4 py-2 rounded-full cursor-pointer text-lg md:text-xl 2xl:text-4xl">
        <slot></slot>
    </button>
</template>
